<div class="flex flex-col h-full w-full overflow-hidden">
    <div class="flex justify-between items-center p-4 h-auto flex-shrink-0">
        <!-- Logo -->
        <div class="w-30 h-auto">
            <img class="w-90 h-auto" src="images/logo/logo.svg" />
        </div>

        <!-- Close button -->
        <button mat-icon-button mat-dialog-close (click)="closeDialog()" class="icon-size-2"
            *ngIf="shouldShowCloseButton()" data-testid="close-dialog-btn" aria-label="Close">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <!-- Contenedor con scroll -->
    <div class="flex-grow overflow-y-auto overflow-x-hidden">
        <div class="flex flex-col p-4">
            <!-- Title -->
            <div class="flex flex-col items-center justify-center w-full text-center h-16">
                <h3 class="text-3xl font-bold leading-tight text-ferrerText w-full text-center">
                    {{ 'login.title' | transloco:titleParams}}
                </h3>
                <div class="mt-0.5 font-medium text-gray-500 w-full text-center">
                    {{'login.subtitle' | transloco}}
                </div>
            </div>

            <form class="mt-8 m-2 flex flex-col flex-grow" [formGroup]="loginSessionForm" #unlockSessionNgForm="ngForm"
                autocomplete="off" (keydown.enter)="handleEnterKey($event)">
                <!-- Email field - Fixed structure -->
                <div class="mb-7 w-full floating-label">
                    <input type="text" id="email" required formControlName="email"
                        [placeholder]="'login.emailPlaceholder' | transloco" autocomplete="off"
                        class="w-full border border-ferrerSecondary rounded-2xl focus:outline-none focus:ring-2 focus:ring-teal-600 focus:border-transparent"
                        [ngClass]="{'border-red-500': loginSessionForm.get('email')?.invalid && loginSessionForm.get('email')?.touched}"
                        data-testid="login-email-input" />
                    <label for="email" class="floating-label">{{'login.emailPlaceholder' | transloco}}</label>
                    <div class="h-4 mt-1 ml-2">
                        <div *ngIf="loginSessionForm.get('email')?.invalid && loginSessionForm.get('email')?.touched"
                            class="text-base text-red-500">
                            <div *ngIf="loginSessionForm.get('email')?.errors?.['required']" class="flex items-center">
                                <mat-icon class="text-red-500 mr-1"
                                    style="font-size: 16px; height: 16px; width: 16px; margin-bottom: 2px;">error_outline</mat-icon>
                                <span>{{'login.emailMissing' | transloco}}</span>
                            </div>
                            <div *ngIf="loginSessionForm.get('email')?.errors?.['email']" class="flex items-center">
                                <mat-icon class="text-red-500 mr-1"
                                    style="font-size: 16px; height: 16px; width: 16px; margin-bottom: 2px;">error_outline</mat-icon>
                                <span>{{'validations.invalidEmailFormat' | transloco}}</span>
                            </div>
                            <div *ngIf="loginSessionForm.get('email')?.errors?.['emailNotFound']"
                                class="flex items-center">
                                <mat-icon class="text-red-500 mr-1"
                                    style="font-size: 16px; height: 16px; width: 16px; margin-bottom: 2px;">error_outline</mat-icon>
                                <span>{{'errors.emailNotFound' | transloco}}</span>
                            </div>
                        </div>
                        <div *ngIf="emailApiError" class="text-base text-red-500 flex items-center">
                            <mat-icon class="text-red-500 mr-1"
                                style="font-size: 16px; height: 16px; width: 16px; margin-bottom: 2px;">error_outline</mat-icon>
                            <span>{{ emailApiError }}</span>
                        </div>
                    </div>
                </div>

                <!-- Password field - Fixed structure -->
                <div class="mb-4 w-full">
                    <div class="floating-label password-field">
                        <input type="password" id="password" required formControlName="password"
                            [placeholder]="'login.passwordPlaceholder' | transloco" autocomplete="new-password"
                            #passwordField
                            class="w-full border border-ferrerSecondary rounded-2xl focus:outline-none focus:ring-2 focus:ring-teal-600 focus:border-transparent"
                            [ngClass]="{'border-red-500': loginSessionForm.get('password')?.invalid && loginSessionForm.get('password')?.touched}"
                            data-testid="login-password-input" />
                        <label for="password" class="floating-label">{{'login.passwordPlaceholder' | transloco}}</label>
                        <button mat-icon-button type="button" class="toggle-password absolute" (click)="
                            passwordField.type === 'password'
                                ? (passwordField.type = 'text')
                                : (passwordField.type = 'password')
                        " matSuffix>
                            @if (passwordField.type === 'password') {
                            <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:eye'"></mat-icon>
                            }
                            @if (passwordField.type === 'text') {
                            <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:eye-slash'"></mat-icon>
                            }
                        </button>
                    </div>
                    <!-- Fixed height error container - Adjusted height and margins -->
                    <div class="h-3 -mt-3.5 ml-2">
                        <div *ngIf="loginSessionForm.get('password')?.invalid && loginSessionForm.get('password')?.touched"
                            class="text-base text-red-500 flex items-center">
                            <mat-icon class="text-red-500 mr-1"
                                style="font-size: 16px; height: 16px; width: 16px;">error_outline</mat-icon>
                            <span>{{ getPasswordErrorMessage() }}</span>
                        </div>
                        <div *ngIf="passwordApiError" class="text-base text-red-500 flex items-center">
                            <mat-icon class="text-red-500 mr-1"
                                style="font-size: 16px; height: 16px; width: 16px;">error_outline</mat-icon>
                            <span>{{ passwordApiError }}</span>
                        </div>

                        @if(apiResendEmailError) {
                        <mat-error class="text-base text-red-500 mt-3 flex items-center justify-center">
                            <mat-icon class="text-red-500 mr-1" style="font-size: 16px; height: 16px; width: 16px; margin-bottom: 2px;">error_outline</mat-icon>
                            <span>{{ apiResendEmailError }}</span>&nbsp;
                            <button (click)="openEmailVerifiedDialog()"
                                class="text-[#006E75] hover:text-[#003E42] underline hover:underline">
                                {{ 'otpvalidation.otpresendemail' | transloco }}
                            </button>
                        </mat-error>
                        }

                    </div>
                </div>

                <!--otp section-->
                <div class="mt-0.5 flex justify-end">
                    <p class="text-base text-gray-500 text-right">
                        {{'login.forgotPassword' | transloco}}
                        <span>
                            {{'login.insertPassword' | transloco}}
                        </span>
                        <button
                            [ngClass]="'text-[#006E75] hover:text-[#003E42] underline hover:underline underline-offset-2'"
                            (click)="openOtpDialog()" data-testid="forgot-password-link">
                            {{'login.sendOTPmsg' | transloco}}
                        </button>
                        <mat-icon [matTooltip]="'login.toolTip' | transloco" matTooltipPosition="right"
                            matTooltipClass="custom-tooltip"
                            class="question-icon ml-2 inline-flex items-center justify-center"
                            style="width: 20px; height: 20px; font-size: 14px; line-height: 20px; vertical-align: middle;">
                            ?
                        </mat-icon>
                    </p>
                </div>

                <!-- Submit button -->
                <button class="my-button bg-ferrerlink text-white btnactions-base fuse-mat-button-large mt-4"
                    mat-flat-button (click)="login()" type="submit" data-testid="login-submit-btn">
                    <div class="flex items-center justify-center">
                        <mat-spinner *ngIf="isLoading" [diameter]="20" class="mr-2"></mat-spinner>
                        <span>{{ isLoading ? ('login.logging' | transloco) : ('login.loginBtn' | transloco) }}</span>
                    </div>
                </button>
            </form>

            <div class="mt-1 text-center pb-4">
                {{ 'login.registerMsg' | transloco}} <br>
                <button class="text-[#006E75] hover:text-[#003E42] underline hover:underline underline-offset-2 "
                    (click)="openRegisterDialog()" data-testid="register-link">
                    {{ 'login.registerLink' | transloco}}
                </button>
            </div>
        </div>
    </div>
</div>